import React, { useEffect, useRef, useState } from 'react'
import { Form, IFormFields } from "./Form";
import { Toast } from "primereact/toast";
import { Form2, IFormValues } from './Form2';
import { Fetch } from '../../../shared/Fetch';
import { Table } from './Table';
import { Card } from 'primereact/card';
import { ILogin } from '../../../models/Login';

export interface DiceLocation {
    country?: string;
    state?: string;
    city?: string;
}

export interface IMainForm {
    q: string;
    description?: string | null;
    locations?: { value: string, distance?: number, distanceUnit?: string }[];
    // locations?: DiceLocation[];
    timezones?: string[];
    willingToRelocate?: boolean;
}

interface ISideFilterForm {
    searchType: "Integrated" | "Resume" | "Semantic";
    jobTitleKeyword?: string;
    skillYearsOfExperience?: string[];
    hasEmail?: boolean;
    language?: string;
    workPermit?: string[];
    currency?: string;
    frequency?: "yearly" | "hourly" | "monthly";
    compensation?: {
        min?: number | null,
        max?: number | null,
        currency?: string,
        frequency?: string | "yearly" | "hourly" | "monthly",
        includeUnspecified?: boolean,
    }
}

interface DiceSearchBody {
    q: string;
    locations?: { value: string; distance?: number; distanceUnit?: string }[];
    jobTitleKeyword?: string;
    skillYearsOfExperience?: string[];
    searchType?: "Resume" | "Integrated" | "Semantic";
    hasEmail?: boolean;
    hasPhoneNumber?: boolean;
    yearsExperience?: { min?: number; max?: number };
    compensation?: {
        min?: number | null;
        max?: number | null;
        currency?: string;
        frequency?: string | "yearly" | "hourly" | "monthly";
        includeUnspecified?: boolean;
    };
    educationDegree?: string;
    employmentType?: string;
    language?: string;
    socialProfiles?: string[] | null;
    workPermit?: string[];
    workPermitLocation?: string;
    onlyWithSecurityClearance?: boolean;
    travelPreference?: 0 | 25 | 50 | 75 | 100;
    dateResumeLastUpdated?: number;
    lastActive?: number;
}

const Dice = () => {
    const [reload, setReload] = useState(false);
    const [openForm2, setOpenForm2] = useState(false);
    const [modal, setModal] = useState({ singleData: {}, open: false });
    const [form1, setForm1] = useState<IFormFields>({
        query: "",
        timezone: [],
        relocation: "No",
    });
    const [form2, setForm2] = useState<IFormValues>({
        jobTitleKeywords: [],
        skillsWithYoe: [],
        companyKeywords: [],
        searchType: "Integrated",
        hasEmail: false,
        hasPhoneNumber: false,
        likelyToSwitch: false,
        yearsExperienceMin: null,
        yearsExperienceMax: null,
        educationDegree: [],
        socialProfiles: [],
        language: "",
        employmentType: [],
        workPermitLocation: [],
        workPermit: [],
        travelPreference: null,
        currency: "USD",
        compensationMin: null,
        compensationMax: null,
        frequency: "yearly",
        includeUnspecified: false,
        onlyWithSecurityClearance: false,
        dateResumeLastUpdated: null,
        lastActive: null
    });
    const [form1Data, setForm1Data] = useState<IMainForm>({ q: "" });
    const [form2Data, setForm2Data] = useState<ISideFilterForm>({ searchType: "Integrated" });
    const [formPayload, setFormPayload] = useState<DiceSearchBody>({ q: "" });
    const [loading, setLoading] = useState<boolean>(false);
    const [useageData, setUseageData] = useState({ customerId: 0, quota: 0, viewsConsumed: 0, viewsRemaining: 0 } as { customerId?: number, quota?: number, viewsConsumed?: number, viewsRemaining?: number });
    const [viewSideFilter, setViewSideFilter] = useState<boolean>(false);

    const toast = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    loginObj.roles.forEach((role) => {
        _roles.push(role.role_ID);
    });

    const buildDiceQuery = (query: string) => {
        if (!query) return "";

        // Replace symbols with Dice operators
        let cleaned = query
            .replace(/&/g, " AND ")
            .replace(/\|/g, " OR ")
            .replace(/\s+/g, " ")
            .trim();

        // Avoid multiple consecutive operators
        cleaned = cleaned.replace(/\b(AND|OR)\s+(AND|OR)\b/g, "$1");

        return cleaned;
    };

    useEffect(() => {
        const payload: DiceSearchBody = {
            ...form1Data,
            ...form2Data,

            q: buildDiceQuery(form1Data.q),
        };

        setFormPayload({ ...payload, socialProfiles: ((payload?.socialProfiles && payload?.socialProfiles?.length > 0 && payload?.socialProfiles?.filter((el: string) => el === "all").length > 0) ? null : payload?.socialProfiles) });
    }, [form1Data, form2Data]);

    const updateToken = async () => {
        await Fetch("MassMail/token", "GET", null, null, toast);
    }

    const getViewAccess = async () => {
        const response = await Fetch("MassMail/getViewAccess", "GET", null, `profile_ID=${"forViewCount"}`, toast);
        if (response) {
            const data: { isAccess: boolean, message?: string, maxViewsAllowed?: number, viewsConsumed?: number } = await response.json();
            const errorMessage = data?.message || "";
            if (data.isAccess === true) {
                setUseageData({ customerId: 0, quota: (data.maxViewsAllowed || 0), viewsConsumed: (data.viewsConsumed || 0), viewsRemaining: ((data.maxViewsAllowed || 0) - (data.viewsConsumed || 0)) });
            } else toast.current.show({ severity: "error", summary: 'Error', detail: errorMessage, life: 3000, });
        }
    }

    useEffect(() => {
        updateToken();
        if (!_roles.includes(1)) {
            getViewAccess();
        }
    }, []);


    return (
        <>
            <Form reload={reload} setReload={setReload} form1={form1} setForm1={setForm1} setForm1Data={setForm1Data} toast={toast} loading={loading} setLoading={setLoading} />
            <Card className='mt-2 flex flex-row-reverse'><span><b>Remaining Views :</b> {useageData?.viewsRemaining}/{useageData?.quota}</span></Card>
            <div className='flex flex-row gap-2' style={{ minWidth: 0 }} >
                <div className='w-3' style={{ minWidth: 0, overflow: 'hidden' }}>
                    {viewSideFilter === true && <Form2 reload={reload} setReload={setReload} hideDialog={() => setOpenForm2(false)} form2={form2} setForm2={setForm2} setForm2Data={setForm2Data} toast={toast} loading={loading} setLoading={setLoading} />}
                </div>
                <div className='mt-3 w-9' style={{ overflowY: "scroll", minWidth: 0 }}>
                    <Table body={formPayload} reload={reload} toast={toast} loading={loading} setLoading={setLoading} setUseageData={setUseageData} setViewSideFilter={setViewSideFilter} />
                </div>
            </div>
            <Toast ref={toast} />
        </>
    )
}

export default Dice
